import SectionHeading from "@/components/base/SectionHeading";
import { characters } from "@/mocks/homeContent";

const avatarIcons = ["ri-user-line", "ri-user-smile-line", "ri-women-line", "ri-group-line"];

export default function Characters() {
  return (
    <section id="characters" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading kicker="Characters" title={characters.title} desc={characters.desc} />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {characters.list.map((person, index) => (
            <article
              key={person.name}
              className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className={`${avatarIcons[index % avatarIcons.length]} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{person.name}</h3>
                  <p className="text-xs text-foreground-500">{person.role}</p>
                </div>
              </div>

              <span className="mt-4 inline-flex w-fit items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900">
                <i className="ri-arrow-right-double-line"></i>
                {person.tag}
              </span>

              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{person.desc}</p>

              <div className="mt-4 flex items-start gap-2 border-t border-background-200/70 pt-3">
                <i className="ri-focus-3-line mt-0.5 text-accent-700"></i>
                <span className="text-xs leading-relaxed text-foreground-500">{person.trait}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}